import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min'
import { UserAction } from '@app/user-actions/components/user-actions-menu/user-actions-menu.component'
import { UserDateFormattingService } from '@app/core/_services/user-date-formatting.service'
import {
    ALL_ACTIVITY_TAGS,
    ALL_DESCRIPTION_TAGS,
} from '@app/shared/components/profile-tag-selector/profile-tag-selector.component'
import { ProfileTags } from '@app/core/_models'

@Component({
    selector: 'app-profile-info-general',
    templateUrl: './profile-info-general.component.html',
    styleUrls: ['./profile-info-general.component.scss'],
    standalone: false,
})
export class ProfileInfoGeneralComponent implements OnInit {
    @Input() name: string
    @Input() email: string = ''
    @Input() userID: string = ''
    @Input() memberSince: number
    @Input() timeZone: string
    @Input() profileUrl: string
    @Input() photo: string
    @Input() isFmAdmin: boolean
    @Input() numCompletedSessions: number
    @Input() uid: string
    @Input() status: number
    @Input() valid: boolean
    @Input() saved: boolean
    @Input() snoozeStatus: boolean
    @Input() snoozeExpiresAt: string
    @Input() sharedAvailability: boolean
    @Input() lastMetSessionTime: number | null
    @Input() sharedSessions: number
    @Input() profileTags: ProfileTags
    @Output() onUserAction = new EventEmitter<UserAction>()

    public memberSinceString: string = ''
    public snoozeTooltip: string = ''
    public lastMet: string = ''

    public descriptionTagDisplayNames: string[] = []
    public activityTagDisplayNames: string[] = []

    constructor(private dateFormat: UserDateFormattingService) {}

    ngOnInit() {
        this.descriptionTagDisplayNames = this.profileTags?.descriptionTags?.map(
            (tag) => ALL_DESCRIPTION_TAGS.find((t) => t.value === tag).displayName,
        )
        this.descriptionTagDisplayNames = this.descriptionTagDisplayNames || []
        this.activityTagDisplayNames = this.profileTags?.activityTags?.map(
            (tag) => ALL_ACTIVITY_TAGS.find((t) => t.value === tag).displayName,
        )
        this.activityTagDisplayNames = this.activityTagDisplayNames || []
    }

    ngOnChanges() {
        this.memberSinceString = moment(this.memberSince).format('MMM Do, YYYY')
        this.lastMet = this.dateFormat.generateLastMetString(this.lastMetSessionTime)

        this.snoozeTooltip =
            'Snoozed ' +
            this.dateFormat.generateSnoozeUntilString(this.snoozeExpiresAt, this.timeZone)
    }
}
